export const SEGMENT_SKU_VIEWED_SOURCE = 'marketplace';
export const SEGMENT_SKU_VIEWED_PRODUCT_TYPE = 'credit_cards';
export const SEGMENT_SKU_VIEWED_LEVEL = 'offer';
export const SEGMENT_DEPLOYABLE_VERSION = '1.0.0';
